import { ThemeUICSSObject } from 'theme-ui';

export const fieldLabel: ThemeUICSSObject = {
  overflow: 'hidden',

  '.fieldLabel__label': {
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
  },

  '& > div': {
    display: 'flex',
    alignItems: 'center',
  },

  '.autocomplete__keyhandler': {
    width: '100%',
  },

  '.fieldLabel__error': {
    color: 'palette.error.main',
    fontWeight: 'bold',
  },
};
